export class UserAppRole {
	constructor (
			public id:number = 0,
			public user_id:number = 0,
			public app_id:number = 6, // proinvel
			public role_id:number = 0,
	) { }


	static fromJson (json:any) {
		if (!json) return;

		return new UserAppRole (
			json.id,
			json.user_id,
			json.app_id,
			json.role_id
		);
	}


	toJson (stringify?: boolean):any {
		var doc = {
			id: this.id,
			user_id: this.user_id,
			app_id: this.app_id,
			role_id: this.role_id
		};

		return stringify ? JSON.stringify({ resource: [doc] }) : doc;
	}

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/models/user_app_role.ts